<template>
  <div id="mpc">
    <button
      v-on:click="openSidebar"
      class="btn btn-action btn-link show-lg p-absolute"
    >
      <more-vertical-icon />
    </button>

    <div id="menu" class="p-absolute">
      <button
        v-if="outputType"
        v-on:click="ConfigStore.data.config.outputTab = outputType"
        class="btn btn-action btn-link tooltip tooltip-bottom"
        data-tooltip="MATPOWER Output"
        aria-label="Show MATPOWER output dialog"
      >
        <terminal-icon />
      </button>

      <button
        v-on:click="showModal = true"
        class="btn btn-action btn-link"
        aria-label="Show diagram options dialog"
      >
        <sliders-icon />
      </button>

      <Menu></Menu>
    </div>

    <div id="toasts">
      <success-toast />
      <error-toast />
    </div>

    <Diagram v-if="ConfigStore.data.config.graph === '2D'" />
    <Graph v-if="ConfigStore.data.config.graph !== '2D'" />
    <ConfigModal :show="showModal" @close="showModal = false" />
  </div>
</template>

<script>
import { TerminalIcon, SlidersIcon, MoreVerticalIcon } from "vue-feather-icons";

import Sidebar from "../components/Sidebar";
import Menu from "../components/Menu";
import Diagram from "../components/Diagram";
import SuccessToast from "../components/SuccessToast";
import ErrorToast from "../components/ErrorToast";
import ConfigModal from "../components/ConfigModal";

import ConfigStore from "../stores/ConfigStore";
import IOStore from "../stores/IOStore";
import PFStore from "../stores/PFStore";
import OPFStore from "../stores/OPFStore";

const Graph = () =>
  import(/* webpackChunkName: "graph" */ "../components/Graph");

export default {
  name: "MPC",
  data() {
    return {
      ConfigStore: ConfigStore,
      showModal: false
    };
  },
  computed: {
    outputType() {
      if (IOStore.methods.output()) {
        return "io";
      } else if (PFStore.methods.getOutput()) {
        return "pf";
      } else if (OPFStore.methods.getOutput()) {
        return "opf";
      } else {
        return "";
      }
    }
  },
  methods: {
    openSidebar: Sidebar.methods.openSidebar
  },
  components: {
    Menu,
    Diagram,
    Graph,
    ConfigModal,
    SuccessToast,
    ErrorToast,
    MoreVerticalIcon,
    TerminalIcon,
    SlidersIcon
  }
};
</script>

<style lang="scss" scoped>
#mpc {
  min-height: 100vh;
  display: flex;
}

#menu {
  right: 0;
  z-index: 100;
}

#toasts {
  width: 85vw;
  max-width: 360px;
  position: fixed;
  right: 5vh;
  bottom: 5vh;
}
</style>
